import React from "react";
import { ArrowUpRight, ShieldCheck, ShoppingBag, Undo2 } from "lucide-react";

import { SHOPIFY_APP_STORE_URL } from "./constants";
import { CASH_IMPACT_LABEL, OPPS_COUNT } from "./aigoMetrics";
import SectionLabel from "./SectionLabel";

export const FinalCta = () => (
  <section
    id="final-cta"
    data-testid="final-cta-section"
    className="px-6 md:px-10 py-20 md:py-24 border-t border-slate-100 bg-gradient-to-br from-emerald-50 via-white to-emerald-50"
  >
    <div className="max-w-4xl mx-auto text-center">
      <SectionLabel>Ready when you are</SectionLabel>
      <h2 className="text-3xl md:text-5xl lg:text-6xl text-slate-900 mt-4 mb-4 tracking-tight font-bold leading-[1.05]">
        <span className="text-emerald-600">Discover your {CASH_IMPACT_LABEL}</span> in growth · free.
      </h2>
      <p className="text-slate-600 max-w-2xl mx-auto text-base md:text-lg leading-relaxed">
        Connect Shopify in 60 seconds. Get your Growth Score, every $-Leak, every Untapped opportunity — no card required. Fix them when you’re ready.
      </p>

      <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
        <a
          href={SHOPIFY_APP_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="final-cta-primary"
          className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-full bg-emerald-500 hover:bg-emerald-600 text-white text-base font-bold shadow-lg shadow-emerald-500/30 transition"
        >
          <ShoppingBag className="w-4 h-4" />
          Start free · connect Shopify
          <ArrowUpRight className="w-4 h-4" />
        </a>
        <a
          href="#overview"
          data-testid="final-cta-secondary"
          className="inline-flex items-center justify-center gap-2 px-6 py-4 rounded-full border border-slate-300 hover:border-emerald-400 hover:text-emerald-700 text-slate-700 text-base font-semibold transition"
        >
          Re-watch the 45s demo
        </a>
      </div>

      <div className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-slate-500">
        <span className="inline-flex items-center gap-1.5"><ShieldCheck className="w-4 h-4 text-emerald-600" /> No card to start</span>
        <span className="inline-flex items-center gap-1.5"><ShieldCheck className="w-4 h-4 text-emerald-600" /> Safe by default</span>
        <span className="inline-flex items-center gap-1.5"><Undo2 className="w-4 h-4 text-emerald-600" /> Undo anytime</span>
      </div>

      <div className="mt-8 text-xs text-slate-400">
        {OPPS_COUNT} opportunities · ranked by $ impact · updated live from your store.
      </div>
    </div>
  </section>
);

export default FinalCta;
